<ui-assignee-avatar
  *ngFor="let assignee of visibleAssignees | keyvalue"
  [fromAssigneeId]="assignee.key"
  [hasBorder]="true"
  [borderColor]="assignee.value"
  [uiShowTooltip]="true"
  uiSize="md"></ui-assignee-avatar>

<ng-container *ngIf="config?.assigneesIdColorMap?.size > assigneesLimit && assigneesOnPopover.size > 0">
  <ui-avatar
    class="view-more-avatars-element"
    [uiText]="'+' + assigneesOnPopover.size"
    [hasBorder]="true"
    [uiContent]="hiddenAvatarsTemplate"
    [uiBackdrop]="true"
    uiSize="md"
    ui-popover
    uiTrigger="click"
    uiPlacement="bottomRight"></ui-avatar>
</ng-container>
<ng-template #hiddenAvatarsTemplate>
  <div class="view-more-avatars-wrapper" [class.scroll]="assigneesOnPopover.size >= 10">
    <div class="view-more-avatars-row" *ngFor="let assignee of assigneesOnPopover | keyvalue">
      <ui-assignee-avatar class="sp-mr-6" [fromAssigneeId]="assignee.key" [hasBorder]="true" [borderColor]="assignee.value" uiSize="md"></ui-assignee-avatar>
      <ui-assignee-name [fromAssigneeId]="assignee.key"></ui-assignee-name>
    </div>
  </div>
</ng-template>
